<!-- 满减课程卡片 -->
<template>
  <div class="full-reduction-card">
    <div
        class="jointPreferencesCard"
        :class="{ active: selected, disabled: courseInfo.isSoldOut || courseInfo.isBuy }"
    >
      <!-- 选中状态icon -->
      <span
          class="check"
          v-if="!courseInfo.isSoldOut && !courseInfo.isBuy"
          @click="chooseCourse"
      ></span>
      <!-- 标题 -->
      <h1 class="title" @click="jumpCourse(courseInfo.productId)">
        <i v-if="courseInfo.name.substr(0,1)=='【'" class="title-special-processing"/>{{ courseInfo.name }}
      </h1>
      <div class="jointPreferencesCard_conent">
        <!-- 左侧sku，课时，开课时间 -->
        <div class="left_sku">
          <div
              class="sku_info"
              v-if="courseInfo.skuInfo && courseInfo.skuInfo.skuName.length > 0"
              @click="openSku"
          >
            <span>规格： {{ String(courseInfo.skuInfo.skuName) }}<img src="../../../assets/img/productDetail/icon_edit.png" alt=""/></span>
          </div>
          <div class="times" @click="chooseCourse">
            <span v-if="courseInfo.classPeriod">共{{ courseInfo.classPeriod }}课时</span>
            <span v-if="courseInfo.startTime">开课时间：{{ courseInfo.startTime.slice(0, 10) }}</span>
          </div>
        </div>
        <!-- 售价+优惠券的价格 -->
        <div class="right_price" @click="chooseCourse">
          <!-- 当前售价 -->
          <div class="price" :class="{active: courseInfo.selected && courseInfo.currPrice!==courseInfo.skuInfo.singleDiscountPrice }" v-if="courseInfo.skuInfo">
            <span class="flag" v-show="courseInfo.skuInfo.promotionLabel">{{courseInfo.skuInfo.promotionLabel === 1 ? '折后价' : '秒杀' }}</span>
            <span>￥</span>
            <b>{{ calculationPrice(courseInfo.skuInfo.singleDiscountPrice).b }}</b>
            <span>{{ calculationPrice(courseInfo.skuInfo.singleDiscountPrice).s }}</span>
          </div>
          <!-- 优惠后价格 -->
          <!-- <div
              class="price discount_price"
              v-if="courseInfo.currPrice && courseInfo.selected"
          > -->
           <div
              class="price discount_price"
              v-if="courseInfo.selected && courseInfo.currPrice!==courseInfo.skuInfo.singleDiscountPrice"
          >
            <span>优惠后</span>&nbsp;&nbsp;<span>￥</span><b>{{ calculationPrice(courseInfo.currPrice).b }}</b>
            <span>{{ calculationPrice(courseInfo.currPrice).s }}</span>
          </div>
        </div>
      </div>
    </div>
    <FullReductionSkuInfo v-bind="$attrs" v-on="$listeners" ref="sku" :courseInfo="courseInfo" />
  </div>
</template>
<script>
import { priceCount } from '@/utils/tools';
// eslint-disable-next-line import/extensions
import FullReductionSkuInfo from '@/components/courseDetail/fullReduction/FullReductionSkuInfo';

export default {
  components: {
    FullReductionSkuInfo,
  },
  data() {
    return {
      selected: false, // 课程选中的状态
    };
  },
  inheritAttrs: false,
  props: {
    // 课程信息+sku
    courseInfo: {
      type: Object,
      default: () => {},
    },
  },
  watch: {},
  mounted() {
    // console.log(this.courseInfo);
  },
  methods: {
    // 价格小数位处理
    calculationPrice(price) {
      return priceCount(price);
    },
    // 打开sku弹窗
    openSku() {
      this.$refs.sku.showSku = true;
    },
    // 选择课程
    chooseCourse() {
      if (this.courseInfo.isSoldOut || this.courseInfo.isBuy) return;
      this.selected = !this.selected;
      this.sendCourse();
    },
    // 将选中的课程,回传到父组件
    sendCourse() {
      // console.log(this.courseInfo, this.selected, '------- 发送选中的课程');
      this.$emit('triggerChecked', this.courseInfo, this.selected);
    },
    // 查看详情
    jumpCourse(courseId) {
      // console.log(courseId, this.$route.query.courseId);
      if (Number(this.$route.query.courseId) === courseId) return;
      this.$router.push({
        path: '/courseDetail',
        query: {
          courseId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.disabled.jointPreferencesCard {
  background: #eee;
  // .jointPreferencesCard_conent .right_price {
  //   // width: 100%;
  // }
}
.jointPreferencesCard {
  position: relative;
  box-sizing: border-box;
  width: 677px;
  margin: 22px auto 0;
  padding: 36px;
  background: #fff;
  border: 1.1px solid #fff;
  border-radius: 15px;

  .check {
    position: absolute;
    top: -1px;
    right: -1px;
    z-index: 200;
    display: inline-block;
    width: 40px;
    height: 32px;
    background: url('../../../assets/img/productDetail/icon_not_check.png') no-repeat left center;
    background-size: contain;
  }
  .title {
    color: #333;
    font-weight: 500;
    font-size: 26px;
    line-height: 40px;
  }
  .jointPreferencesCard_conent {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: space-between;

    .right_price {
      display: flex;
      flex: 1;
      flex-wrap: wrap;
      align-items: flex-end;
      justify-content: flex-end;
      min-width: 200px;
      text-align: right;

      div {
        width: 100%;
        // display: flex;
        // justify-content: flex-end;
        // align-items: center;
        // flex-wrap: wrap;
      }
      .noy_buy {
        color: #a5a5a5;
        font-size: 22px;
        text-align: right;
      }
    }

    .sku_info {
      display: flex;
      align-items: center;
      padding-top: 29px;

      span {
        padding: 3px 10px;
        color: #787878;
        font-weight: 400;
        font-size: 22px;
        line-height: 28px;
        background: #fafafa;
        border-radius: 7px;
        img {
          position: relative;
          top: 4px;
          width: 25px;
          margin-left: 5px;
        }
      }
    }

    .times {
      display: flex;
      flex-wrap: wrap;

      span {
        margin-top: 29px;
        margin-right: 14px;
        padding-right: 14px;
        color: #787878;
        font-size: 22px;
        line-height: 28px;
        border-right: 1px solid #f5f5f5;
        &:last-child {
          margin-right: 0;
          padding-right: 0;
          border: none;
        }
      }
    }
    .price {
      color: #ff6c02;
      font-weight: 600;
      font-size: 22px;
      text-align: right;
      .flag {
        padding-right: 7px;
        color: #ff6c02;
        font-size: 22px;
      }
      b {
        color: #ff6c02;
        font-weight: 600;
        font-size: 33px;
      }

      &.active {
        padding-bottom: 4px;
        text-align: right;
        // .flag {
        //   display: none;
        // }
        span,
        b {
          color: #787878;
          font-size: 25px;
        }
      }
    }
  }

  &.active {
    border: 1.1px solid #ff6c02;
    .check {
      background: url('../../../assets/img/productDetail/icon_checked.png') no-repeat left center;
      background-size: contain;
    }
  }
}
</style>
